export const NEW_USER_QUESTION_GATES = {
  store_owner: null,
  referral_source: null,
  contact_source: null,
  demographics: null,
  hair_photo: null,
  hair_prediction_review: null,
  hair_prediction_confirm: null,
  hair_prediction_corrected_value: null,
  hair_profile: 'hair_diagnostics',
  routine_preferences: 'hair_routine',
  medical_lifestyle: null,
  diagnosis: null,
  recommendations: null,
  eco_routine: null,
}

export const EXISTING_USER_QUESTION_GATES = {
  // menu / branch selection
  last_visit_summary: null,
  option_update_profile: null,
  option_new_product: null,
  option_restart_analysis: null,
  option_someone_else: null,

  // profileSummary (welcome-back profile card display labels)
  profile_title: null,
  profile_hair_class: null,
  profile_priorities: null,
  profile_concerns: null,
  profile_routine: null,
  profile_last_diagnostic: null,

  // updateProfile branch
  update_intro: null,
  update_state_challenges: null,
  update_routine: null,
  update_routine_details: null,
  update_medical: null,
  update_medical_details: null,
  update_complete: null,

  // newProduct branch
  new_product_intro: null,
  new_product_profile_intro: null,
  // → profile card here reuses the profileSummary labels above, not redefined
  profile_confirm_question: null,
  profile_confirm_yes: null,
  profile_confirm_no: null,
  profile_confirmed: null,
  new_product_recommendations: null,
  view_product_routine: null,
  select_product: null,
  buy_yes: null,
  profile_update_prompt: null,

  // restartAnalysis branch
  restart_intro: null,
  // → reuses hair_photo, hair_prediction_review, hair_prediction_confirm,
  //   hair_prediction_corrected_value, hair_profile — gated via NEW_USER_QUESTION_GATES

  // someoneElse branch
  someone_else_intro: null,
  analysis_recipient: null,
  someone_else_adult_intro: null,
  someone_else_child_intro: null,
  // demographics, hair_profile, routine_preferences, diagnosis, recommendations
  // reused from NEW_USER_QUESTION_GATES — not redefined here

  // shared
  share_title: null,
  share_subtitle: null,
}

export const BUTTON_STEP_IDS = new Set([
  'store_owner',
  'referral_source',
  'contact_source',
  'self_or_child',
  'hair_prediction_confirm',
  'hair_prediction_corrected_value',

  // existingUserFlow button-driven steps
  'option_update_profile',
  'option_new_product',
  'option_restart_analysis',
  'option_someone_else',
  'profile_confirm_question',
  'analysis_recipient',
  'buy_yes',
])
